import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-navy text-white overflow-hidden pt-20 pb-24 lg:pt-32 lg:pb-32" data-id="element-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-101">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-102">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-103">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-navy-light/50 border border-gold/30 text-gold text-sm font-medium mb-6" data-id="element-104">
              <span className="w-2 h-2 rounded-full bg-gold" data-id="element-105"></span>
              Nueva Guía Digital
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-[1.1]" data-id="element-106">
              AGENTE DE CITAS PARA{' '}
              <span className="text-gold italic" data-id="element-107">BIENES RAÍCES</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-300 mb-8 leading-relaxed font-light" data-id="element-108">
              Guía práctica para mujeres latinas que quieren generar ingresos
              desde casa ayudando a agentes inmobiliarios.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-109">
              <a href="#comprar" onClick={e => {
              e.preventDefault();
              document.getElementById('comprar')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="w-full sm:w-auto px-8 py-4 bg-gold hover:bg-gold-light text-navy-dark font-semibold rounded-lg shadow-[0_4px_14px_0_rgba(212,168,83,0.39)] transition-all duration-300 flex items-center justify-center gap-2 group cursor-pointer" data-id="element-110">
                ¡Quiero Mi Copia!
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-111" />
              </a>
            </div>

            <div className="mt-6 flex items-center gap-4 text-sm text-gray-400" data-id="element-112">
              <div className="flex items-center gap-1.5" data-id="element-113">
                <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-114" />
                <span data-id="element-115">Guía digital</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-116">
                <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-117" />
                <span data-id="element-118">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-119">
                <CheckCircle2 className="w-4 h-4 text-gold" data-id="element-120" />
                <span data-id="element-121">En español</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:ml-auto" data-id="element-122">
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform -translate-x-1/2 translate-y-1/4" data-id="element-123"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jRozidLeLShhH7jzpLn2Ch/mujers_agentes.png" alt="Mujer latina profesional trabajando desde casa" className="relative z-10 w-full max-w-lg mx-auto rounded-2xl shadow-2xl border border-navy-light/50 object-cover" data-id="element-124" />
          </motion.div>
        </div>
      </div>
    </section>;
}